import { createApp } from 'vue'
import App from './App.vue'
import { createPinia } from 'pinia';  // Import Pinia
import { createPersistedState } from 'pinia-plugin-persistedstate'
import router from './router/router'
import Login from './pages/LoginPage.vue'
import Products from './pages/ProductsPage.vue'
import { VueResponsiveness } from 'vue-responsiveness'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import { i18n } from './i18n'
import './index.css'
import HowToReturnPage from "@/pages/HowToReturnPage.vue";

// Create Pinia instance
const pinia = createPinia();
pinia.use(createPersistedState({
  storage: sessionStorage,
}))


const app = createApp(App)
    .use(router)
    .use(pinia)
    .use(i18n)
    .use(ElementPlus)
    .use(VueResponsiveness, {
      'sm': 768,
      'md': 1024,
      'lg': 1440,
      'xl': 1920,
    })


app.component('login-item', Login)
app.component('products-item', Products)
app.component('return-item', HowToReturnPage)


router.isReady().then(() => {
  app.mount('#app');
});
